exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-dialog {\n  margin: 0 !important;\n}\n.dialog-register, .dialog-login, .dialog-forgot {\n  overflow: hidden !important;\n  max-height: 100% !important;\n}\n.header__nav-loginBox {\n  display: flex;\n  align-items: center;\n}\n@media (max-width: 767px) {\n.dialog-register, .dialog-login, .dialog-forgot {\n    background-color: #FFFFFF;\n}\n}", ""]);

// exports
